<template>
  <main class="main">
    <div class="main__container">
      <slot />
    </div>
  </main>
</template>

<script>
export default {
  name: 'SMain'
}
</script>

<style lang="scss" scoped>
.main {
  display: block;
  padding: 1rem 0;

  background-color: $--color-background;

  @media (min-width: 50rem) {
    padding: 2rem 0;
  }
}

.main__container {
  width: $--container-width;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 $--container-padding;
}
</style>
